
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	AppointmentDateFrom: null as Date | null,
	AppointmentDateTo: null as Date | null,	
	WorkshopIds: [1] as number[] | [1],
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
